import * as tslib_1 from "tslib";
import { GetAccountDetailsUrl, GetAccountUpdateUrl, GetPendingAccountManagementUpdatesUrl } from '../constants';
import { GenericErrorResponseCode, } from '@tradingblock/types';
import { DateFormats, GetMiscellaneousDocumentsMetadataUrl, GetMiscellaneousDocumentsUrl, UploadMiscellaneousDocumentsUrl, } from '..';
import dayjs from 'dayjs';
import { RequestHeaders } from './utilities';
export function GetAccountDetails(api) {
    return (details) => {
        return api.get(GetAccountDetailsUrl, { details });
    };
}
export function GetAccountUpdate(api) {
    return (update) => {
        return api.get(GetAccountUpdateUrl, { update });
    };
}
const blobToBase64 = (blob) => {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
};
export const AccManagement = (api) => ({
    details: GetAccountDetails(api),
    getUpdate: GetAccountUpdate(api),
    uploadMiscellaneousDocument: (file, accountId, documentType, description) => {
        const TakenOn = dayjs(file.lastModified)
            .utc()
            .format(DateFormats.DateTimeApiFormat);
        const data = new FormData();
        data.append('metaData', JSON.stringify({ DocumentName: documentType, ImageName: file.name, TakenOn, Description: description }));
        data.append('file', file);
        return api.authenticated().post(UploadMiscellaneousDocumentsUrl(accountId), data);
    },
    getMiscellaneousDocument: (accountId, documentId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const url = GetMiscellaneousDocumentsUrl(accountId, documentId);
        try {
            const result = yield api.authenticated().getBinary(url, {});
            if (result.status === 200) {
                const base64 = Buffer.from(result.data, 'binary').toString('base64');
                const imageBase64 = `data:${result.headers['content-type']};base64,${base64}`;
                return imageBase64;
            }
        }
        catch (err) {
            console.warn('error requesting miscellaneous document', accountId);
            return {
                responseCode: GenericErrorResponseCode,
                payload: err,
            };
        }
    }),
    getMiscellaneousDocumentMetadata: (accountId, documentId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const url = GetMiscellaneousDocumentsMetadataUrl(accountId, documentId);
        try {
            const result = yield api.authenticated().get(url, { accountId, documentId });
            return result;
        }
        catch (err) {
            console.warn('error requesting miscellaneous document', accountId);
            return {
                responseCode: GenericErrorResponseCode,
                payload: err,
            };
        }
    }),
    firmApproveDocument: (accountId, documentId, note) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const url = `Accounts/FirmApproveMiscellaneousDocument?accountId=${accountId}&documentId=${documentId}`;
        return yield api.authenticated().put(url, note);
    }),
    firmRejectDocument: (accountId, documentId, note) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const url = `Accounts/RejectMiscellaneousDocument?accountId=${accountId}&documentId=${documentId}`;
        return yield api.authenticated().put(url, note);
    }),
    getPendingUpdates: (accountId) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        return yield api.get(GetPendingAccountManagementUpdatesUrl, { accountId }, RequestHeaders);
    }),
});
//# sourceMappingURL=accountManagement.js.map